// extracted by mini-css-extract-plugin
module.exports = {"vanlife":"Vanlife_vanlife__G527j"};